import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { UserSettings } from '../../../../api/users';
import type { RootState } from '../../../../store';
import type { SettingsState, SettingsType } from './types';

const initialState: SettingsState = {
  userSettings: null,
  isLoading: false,
};

const settingsSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setUserSettings: (state, action: PayloadAction<UserSettings>) => {
      state.userSettings = action.payload;
    },
    setIsSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUserSettings, setIsSettingsLoading } = settingsSlice.actions;

export const selectSettings = (state: RootState) => {
  return {
    notifyChecklists: state.settings.userSettings?.notifications?.checklists,
    notifyDocuments: state.settings.userSettings?.notifications?.documents,
    notifyWithEmail: state.settings.userSettings?.receiveEmails,
  } as SettingsType;
};

export const selectIsSettingsLoading = (state: RootState) => state.settings.isLoading;

export default settingsSlice.reducer;
